import type { FC } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';

import { DownIcon } from '@/assets';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { SVGComponent } from '@/types';

type Props = {
  icon: SVGComponent;
  label: string;
  active: boolean;
  onPress: () => void;
};

export const FilterChip: FC<Props> = ({
  icon: Icon,
  label,
  active,
  onPress
}) => {
  const theme = useAppTheme();
  const foreground = active
    ? theme.colors.onSecondaryContainer
    : theme.colors.onSurfaceVariant;
  const iconColor = theme.colors.primary;

  return (
    <Pressable
      accessibilityRole="button"
      onPress={onPress}
      style={[
        styles.chip,
        {
          backgroundColor: active
            ? theme.colors.secondaryContainer
            : theme.colors.surfaceContainerLow
        }
      ]}
    >
      <Icon width={12} height={12} fill={iconColor} />
      <Text
        variant="labelSmall"
        numberOfLines={1}
        style={[styles.chipLabel, { color: foreground, fontWeight: '700' }]}
      >
        {label}
      </Text>
      <DownIcon width={10} height={10} fill={iconColor} />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
    alignSelf: 'flex-start',
    maxWidth: '100%',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    elevation: 3
  },
  chipLabel: {
    flexShrink: 1
  }
});
